import { pickId, pickOne, pickState, searchOf } from '../../lib/searchFilter'
import { EQUIPMENT_TYPES } from '../carriers/api'
import type { LoadFilter } from './api'

/** The load book's filters as its address spells them: `?equipment=Reefer&state=FL&cancelled=true`. */
export function bookFilterFrom(search: URLSearchParams): LoadFilter {
  return {
    includeCancelled: search.get('cancelled') === 'true' ? true : undefined,
    equipment: pickOne(search.get('equipment'), EQUIPMENT_TYPES),
    pickupState: pickState(search.get('state')),
    brokerId: pickId(search.get('broker')),
  }
}

/** The address a filter is written to. */
export function bookSearchFrom(filter: LoadFilter): URLSearchParams {
  return searchOf([
    ['equipment', filter.equipment],
    ['state', filter.pickupState],
    ['broker', filter.brokerId],
    ['cancelled', filter.includeCancelled === true ? 'true' : undefined],
  ])
}
